import Cookies from 'universal-cookie';

let authTokenKey = "Authorization"
let customerIdKey = "customerId"
const hostname = window.location.hostname;
const isLocalhost = hostname === 'localhost' || hostname.endsWith('.local');

const cookieDomain = isLocalhost ? 'localhost' : '.zecurit.com';
const sameSite = isLocalhost?"Lax":"None";

export function storeAuthToken(token, remember) 
{
    let cookies = new Cookies();
    let expireIn = new Date();
    let numberOfDays = 6;
    expireIn.setDate(expireIn.getDate() + numberOfDays);

    cookies.set(authTokenKey, token, {
        path: '/',
        expires: remember ? expireIn : undefined,
        domain: cookieDomain, //make sure this is added in future when hosted in domain
        secure: !isLocalhost, //make sure this is added
        sameSite: sameSite
        //httpOnly: true, make sure this is added 
        //strict: true make sure this is added
    })
}

export function getAuthToken() 
{
    let cookies = new Cookies();
    return cookies.get(authTokenKey,{
        domain: cookieDomain, //make sure this is added in future when hosted in domain
        secure: true, //make sure this is added
        sameSite: sameSite
    })
}

export function clearAuthToken() 
{
    let cookies = new Cookies();
    cookies.remove(authTokenKey, {
        path: '/',
         domain: cookieDomain, //make sure this is added in future when hosted in domain
        secure: true, //make sure this is added
        sameSite: sameSite
        //httpOnly: true, make sure this is added 
        //strict: true make sure this is added
    })
}

export function setCustomerIdInCookies(customerId) 
{
    const cookies = new Cookies();
    cookies.set(customerIdKey, customerId, {
        path: '/',
        domain: cookieDomain,
        secure: !isLocalhost,
        sameSite: sameSite
    });
}

export function getCustomerIdFromCookies() 
{
    const cookies = new Cookies();
    return cookies.get(customerIdKey, {
        domain: cookieDomain,
        secure: true,
        sameSite: sameSite
    });
}

export function clearCustomerIdInCookies() 
{
    const cookies = new Cookies();
    cookies.remove(customerIdKey, {
        path: '/',
        domain: cookieDomain,
        secure: true,
        sameSite: sameSite
    });
}